<div class="schedule-picker">
  <!-- Compact View -->
  <div class="schedule-picker-compact">
    <mat-form-field class="schedule-display-field" [class.expanded]="expanded">
      <mat-label>Schedule</mat-label>
      <input matInput
        [value]="scheduleDescription"
        readonly
        class="schedule-summary"
        (click)="toggleExpanded()">
      <mat-hint>{{ nextRunDisplay }} (Schedule runs in UTC)</mat-hint>
    </mat-form-field>
  </div>

  <!-- Expanded View -->
  @if (expanded) {
    <div class="schedule-picker-expanded"
      >
      <div class="expanded-header">
        <h4>Edit Schedule</h4>
        <button mat-icon-button (click)="toggleExpanded()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <!-- Preset Schedules -->
      <div class="preset-schedules">
        <h5>Quick Presets</h5>
        <div class="preset-groups">
          <div class="preset-group">
            <span class="group-label">Common</span>
            <div class="preset-buttons">
              @for (preset of commonPresets; track preset) {
                <button mat-stroked-button
                  (click)="applyPreset(preset)"
                  [matTooltip]="preset.description">
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>
          <div class="preset-group">
            <span class="group-label">Business</span>
            <div class="preset-buttons">
              @for (preset of businessPresets; track preset) {
                <button mat-stroked-button
                  (click)="applyPreset(preset)"
                  [matTooltip]="preset.description">
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>
          <div class="preset-group">
            <span class="group-label">Maintenance</span>
            <div class="preset-buttons">
              @for (preset of maintenancePresets; track preset) {
                <button mat-stroked-button
                  (click)="applyPreset(preset)"
                  [matTooltip]="preset.description">
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="schedule-content">
        <div class="basic-mode">
          <mat-form-field>
            <mat-label>Schedule Type</mat-label>
            <mat-select [(ngModel)]="basicSchedule.type" (ngModelChange)="onScheduleChange()">
              <mat-option value="hourly">Hourly</mat-option>
              <mat-option value="daily">Daily</mat-option>
              <mat-option value="weekly">Weekly</mat-option>
              <mat-option value="monthly">Monthly</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Hour Selection for Daily/Weekly/Monthly -->
          @if (basicSchedule.type === 'hourly') {
            <div class="hourly-info">
              <mat-icon>info</mat-icon>
              <span>Runs every hour at the top of the hour (minute 0)</span>
            </div>
          }
          @if (basicSchedule.type === 'daily' || basicSchedule.type === 'weekly' || basicSchedule.type === 'monthly') {
            <mat-form-field>
              <mat-label>Hour(s)</mat-label>
              <mat-select [(ngModel)]="basicSchedule.hoursList"
                (ngModelChange)="onScheduleChange()"
                multiple>
                <mat-select-trigger>
                  @if (basicSchedule.hoursList.length === 0 || basicSchedule.hoursList.length === 24) {
                    <span>All hours</span>
                  }
                  @if (basicSchedule.hoursList.length > 0 && basicSchedule.hoursList.length < 24) {
                    <span>
                      {{ basicSchedule.hoursList.length }} hour(s) selected
                    </span>
                  }
                </mat-select-trigger>
                @for (opt of hourOptions; track opt) {
                  <mat-option [value]="opt.value">
                    {{ opt.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (basicSchedule.type === 'weekly') {
            <mat-form-field>
              <mat-label>Day(s) of Week</mat-label>
              <mat-select [(ngModel)]="basicSchedule.dayOfWeekList"
                (ngModelChange)="onScheduleChange()"
                multiple>
                <mat-select-trigger>
                  @if (basicSchedule.dayOfWeekList.length === 0 || basicSchedule.dayOfWeekList.length === 7) {
                    <span>All days</span>
                  }
                  @if (basicSchedule.dayOfWeekList.length > 0 && basicSchedule.dayOfWeekList.length < 7) {
                    <span>
                      {{ basicSchedule.dayOfWeekList.length }} day(s) selected
                    </span>
                  }
                </mat-select-trigger>
                @for (opt of dayOfWeekOptions; track opt) {
                  <mat-option [value]="opt.value">
                    {{ opt.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (basicSchedule.type === 'monthly') {
            <mat-form-field>
              <mat-label>Day(s) of Month</mat-label>
              <mat-select [(ngModel)]="basicSchedule.dayOfMonthList"
                (ngModelChange)="onScheduleChange()"
                multiple>
                <mat-select-trigger>
                  @if (basicSchedule.dayOfMonthList.length === 0 || basicSchedule.dayOfMonthList.length >= 31) {
                    <span>All days</span>
                  }
                  @if (basicSchedule.dayOfMonthList.length > 0 && basicSchedule.dayOfMonthList.length < 31) {
                    <span>
                      {{ basicSchedule.dayOfMonthList.length }} day(s) selected
                    </span>
                  }
                </mat-select-trigger>
                @for (opt of dayOfMonthOptions; track opt) {
                  <mat-option [value]="opt.value">
                    {{ opt.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>
      <!-- Schedule Preview -->
      <div class="schedule-preview">
        <div class="description">
          <mat-icon>schedule</mat-icon>
          <span>{{ scheduleDescription }}</span>
        </div>
        <div class="cron-expression">
          <code>{{ cronExpression }}</code>
          <span class="cron-label">Cron expression (UTC)</span>
        </div>
        @if (nextRunTimes.length > 0) {
          <div class="next-runs">
            <strong>Next runs:</strong>
            <ul>
              @for (time of nextRunTimes.slice(0, 3); track time) {
                <li>
                  {{ time | date:'short':'UTC' }} UTC
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  }
</div>
